
// import Vue from 'vue'
// import VueResource from 'vue-resource'
import { API, MAIN_DOMAIN } from '@/environment'
import axios from '../http/axios/index'
// import store from '@/store/store'

// Vue.use(VueResource)

/**
 * @param {String} url
 * @return { Promise }
 */
export const get = (url) => {
  return new Promise((resolve, reject) => {
    axios.get(`${API}/${url}`).then(response => {
      resolve(response)
    }, error => {
      reject(error)
    })
  })
}

/**
 * Used to Insert Record
 * @param {String} url String
 * @param {Object} data Object
 * @return { Promise } mixed
 */

export const put = (url, data) => {
  return new Promise((resolve, reject) => {
    axios.put(`${API}/${url}`, data || {}).then(response => {
      resolve(response)
    }, error => {
      reject(error)
    })
  })
}

/**
 * Used to Insert Record
 * @param {String} url String
 * @param {Object} data Object
 * @return { Promise } mixed
 */

export const patch = (url, data) => {
  return new Promise((resolve, reject) => {
    axios.patch(`${API}/${url}`, data || {}).then(response => {
      resolve(response)
    }, error => {
      reject(error)
    })
  })
}

/**
 * Used to Delete Record
 * @param {String} url String
 * @return { Promise } mixed
 */
export const del = (url) => {
  return new Promise((resolve, reject) => {
    axios.delete(`${API}/${url}`).then(response => {
      resolve(response)
    }, error => {
      reject(error)
    })
  })
}

export const delWithBody = (url, body) =>
  axios.delete(`${API}/${url}`, { body })

/**
 * Used to Insert/Update record
 * @param {String} url String
 * @param { Object } data Object
 * @return { Promise } mixed
 */
export const post = (url, data) => {
  return new Promise((resolve, reject) => {
    axios.post(`${API}/${url}`, data).then(response => {
      resolve(response)
    }, error => {
      reject(error)
    })
  })
}


/**
 * Used to Insert/Update record
 * @param {String} url String
 * @param { Object } data Object
 * @return { Promise } mixed
 */
 export const post_to_base = (url, data) => {
  return new Promise((resolve, reject) => {
    axios.post(`${MAIN_DOMAIN}/${url}`, data).then(response => {
      resolve(response)
    }, error => {
      reject(error)
    })
  })
}


// axios.interceptors.response.use(
//   response => {
//     return response;
//   },
//   error => {
//     if (error.response.status === 401) {
//       store.dispatch("auth/doLogout").then(() => {
//         this.$acl.change("admin");
//         localStorage.removeItem("userInfo");
//         this.$router.push("/login").catch(() => { });
//       });
//     }
//   }
// );

